import { Trans } from '@lingui/macro';
import { View } from '@react-pdf/renderer';
import React from 'react';
import CloudinaryImage from '../../components/CloudinaryImage';
import type { Collection } from './MyList';
import { Text } from './Text';

export default function Footer({ collection }: { collection: Collection }) {
  return (
    <View
      style={{
        position: 'absolute',
        bottom: '5mm',
        left: '1cm',
        right: '1cm',
        flexDirection: 'row',
        alignItems: 'flex-end',
      }}
    >
      <CloudinaryImage
        src={collection.logo?.fixed?.src}
        height={20}
        width={110}
        gravity="south_west"
        trim
      />
      <View
        style={{
          borderBottom: 1,
          borderBottomColor: '#ccc',
          flexGrow: 1,
          marginRight: 5,
        }}
      />
      <Text style={{ color: '#888' }}>
        <Trans>Created with Bottlebooks</Trans>
      </Text>
    </View>
  );
}
